import React, { useEffect, useState } from "react";
import axios from "axios";
import { Notify } from "notiflix";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ProfileCard = ({ profile }) => (
    <div className="profile-card" id={`profile-card-${profile.profile_id}`}>
        <div className="profile-img-wrapper">
            <img
                src={`https://kovaikongunadumatrimony.com/kkm_admin/public/assets/prof_images/${profile.profile_photo_1}`}
                alt="Profile"
                className="profile-img"
            />
        </div>
        <div className="profile-details">
            <p><strong>பதிவு எண்</strong>: {profile.profile_id}</p>
            <p><strong>பெயர் </strong>: {profile.name}</p>
            <p><strong>வயது </strong>: {profile.age}</p>
            <p><strong>ஜாதகம் </strong>: {profile.jathagam}</p>
            <p><strong>நட்சத்திரம்  </strong>: {profile.star}</p>
            <p><strong>ராசி </strong>: {profile.rasi}</p>
            <p>
                <strong>தொலைபேசி எண் 1</strong>:{" "}
                {profile.mobile_number ? (
                    <a
                        href={`tel:${profile.mobile_number}`}
                        className="text-primary text-decoration-none fw-bold"
                    >
                        {profile.mobile_number}
                    </a>
                ) : (
                    "-"
                )}
            </p>
            <p>
                <strong>தொலைபேசி எண் 2</strong>:{" "}
                {profile.alternative_number ? (
                    <a
                        href={`tel:${profile.alternative_number}`}
                        className="text-primary text-decoration-none fw-bold"
                    >
                        {profile.alternative_number}
                    </a>
                ) : (
                    "-"
                )}
            </p>
        </div>
    </div>
);

const ProfileCardSkeleton = () => (
    <div className="profile-card">
        <div className="profile-img-wrapper">
            <Skeleton height={150} />
        </div>
        <div className="profile-details">
            <p><Skeleton width={120} /></p>
            <p><Skeleton width={150} /></p>
            <p><Skeleton width={100} /></p>
            <p><Skeleton width={130} /></p>
            <p><Skeleton width={140} /></p>
            <p><Skeleton width={100} /></p>
            <p><Skeleton width={160} /></p>
            <p><Skeleton width={160} /></p>
        </div>
    </div>
);

const PurchasedProfileSection = () => {
    const [showAll, setShowAll] = useState(() => {
        const savedShowAll = localStorage.getItem("kkm_purchased_profiles_show_all");
        return savedShowAll ? JSON.parse(savedShowAll) : false;
    });
    const [currentPage, setCurrentPage] = useState(() => {
        const savedPage = localStorage.getItem("kkm_purchased_profiles_page");
        return savedPage ? Number(savedPage) : 1;
    });
    const [profiles, setProfiles] = useState([]);
    const [loading, setLoading] = useState(true);

    const profilesPerPage = 30;

    useEffect(() => {
        const token = JSON.parse(localStorage.getItem("kkm_auth"));
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };

        setLoading(true);
        axios
            .get(
                "https://kovaikongunadumatrimony.com/kkm_backend/public/api/purchase-mobile-number-List",
                { headers }
            )
            .then((response) => {
                if (response.data.status === true) {
                    setProfiles(response.data.data);
                } else {
                    Notify.failure(response.data.message);
                }
            })
            .finally(() => setLoading(false));
    }, []);

    useEffect(() => {
        if (!loading && profiles.length > 0) {
            const lastViewedId = sessionStorage.getItem("last_viewed_profile_id");
            const savedScrollPos = sessionStorage.getItem("all_profiles_scroll_pos");

            if (lastViewedId || savedScrollPos) {
                setTimeout(() => {
                    const element = document.getElementById(`profile-card-${lastViewedId}`);
                    if (element) {
                        element.scrollIntoView({ behavior: "smooth", block: "center" });
                    } else if (savedScrollPos) {
                        window.scrollTo({ top: Number(savedScrollPos), behavior: "smooth" });
                    }
                    sessionStorage.removeItem("last_viewed_profile_id");
                    sessionStorage.removeItem("all_profiles_scroll_pos");
                }, 150);
            }
        }
    }, [loading, profiles]);

    const indexOfLastProfile = currentPage * profilesPerPage;
    const indexOfFirstProfile = indexOfLastProfile - profilesPerPage;
    const currentProfiles = showAll
        ? profiles.slice(indexOfFirstProfile, indexOfLastProfile)
        : profiles.slice(0, 4);

    const totalPages = Math.ceil(profiles.length / profilesPerPage);

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
            localStorage.setItem("kkm_purchased_profiles_page", page.toString());
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    const getPageNumbers = () => {
        const pages = [];
        const maxPagesToShow = 5;
        const half = Math.floor(maxPagesToShow / 2);

        let start = Math.max(1, currentPage - half);
        let end = Math.min(totalPages, start + maxPagesToShow - 1);

        if (end - start + 1 < maxPagesToShow) {
            start = Math.max(1, end - maxPagesToShow + 1);
        }

        if (start > 1) {
            pages.push(1);
            if (start > 2) pages.push("...");
        }

        for (let i = start; i <= end; i++) {
            pages.push(i);
        }

        if (end < totalPages) {
            if (end < totalPages - 1) pages.push("...");
            pages.push(totalPages);
        }

        return pages;
    };

    const handleViewAllClick = () => {
        setShowAll(true);
        setCurrentPage(1);
        localStorage.setItem("kkm_purchased_profiles_show_all", "true");
        localStorage.setItem("kkm_purchased_profiles_page", "1");
    };

    const handleShowLessClick = () => {
        setShowAll(false);
        setCurrentPage(1);
        localStorage.setItem("kkm_purchased_profiles_show_all", "false");
        localStorage.setItem("kkm_purchased_profiles_page", "1");
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <div className="all-profiles-section">
            <h2>Purchased Mobile Numbers ({profiles.length})</h2>
            <div className="row profiles-grid">
                {loading
                    ? Array(4).fill(0).map((_, index) => (
                        <div className="col-xl-6 col-12 mb-4" key={index}>
                            <ProfileCardSkeleton />
                        </div>
                    ))
                    : currentProfiles.map((profile, index) => (
                        <div className="col-xl-6 col-12 mb-4" key={index}>
                            <ProfileCard profile={profile} />
                        </div>
                    ))
                }
            </div>
            {!loading && !showAll && profiles.length > 4 && (
                <div className="view-all-wrapper">
                    <button className="view-all-btn" onClick={handleViewAllClick}>
                        View All
                    </button>
                </div>
            )}
            {!loading && showAll && (
                <>
                    {profiles.length > profilesPerPage && (
                        <nav className="d-flex justify-content-center mt-4">
                            <ul className="pagination shadow-sm rounded-3">
                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => handlePageChange(currentPage - 1)}
                                    >
                                        Prev
                                    </button>
                                </li>
                                {getPageNumbers().map((page, i) => (
                                    <li
                                        key={i}
                                        className={`page-item ${currentPage === page ? "active" : ""} ${
                                            page === "..." ? "disabled" : ""
                                        }`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() => typeof page === "number" && handlePageChange(page)}
                                        >
                                            {page}
                                        </button>
                                    </li>
                                ))}
                                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => handlePageChange(currentPage + 1)}
                                    >
                                        Next
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    )}
                    <div className="view-all-wrapper mt-3">
                        <button className="view-all-btn" onClick={handleShowLessClick}>
                            Show Less
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default PurchasedProfileSection;
